var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import ApplicableDiscountsForm from "../../../components/applicable-discounts/ApplicableDiscountsForm";
import { FormProvider, useForm } from "react-hook-form";
import { UnlinkedApplicationStatus, saveApplicableDiscounts, updateStatus, } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import { completedHomeUnlinkedApplication, completedPage, completedUnlinkedApplication, selectedDiscounts, } from "../../../lib/Avo";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import RouteHeaderLogo from "../../../components/RouteHeaderLogo";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import { useEffectOnceWhen } from "rooks";
import { useHistory } from "react-router-dom";
import usePostUnlinkedAccount from "../../../services/savvy/usePostUnlinkedAccount";
import useUnlinkedApplicationCompleteNextRoute from "../../../features/unlinked-application/useUnlinkedApplicationCompleteNextRoute";
export default function UnlinkedApplicationHomeownersApplicableDiscounts() {
    var _a = useHistory(), goBack = _a.goBack, push = _a.push;
    var dispatch = useAppDispatch();
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _b = useAppSelector(function (_a) {
        var unlinkedApplication = _a.unlinkedApplication;
        return {
            applicableDiscounts: unlinkedApplication.policyHolder.applicableDiscounts,
            status: unlinkedApplication.status.home,
        };
    }), applicableDiscounts = _b.applicableDiscounts, status = _b.status;
    var formMethods = useForm({
        mode: "all",
        defaultValues: applicableDiscounts,
    });
    var postUnlinkedAccount = usePostUnlinkedAccount().postUnlinkedAccount;
    var nextRoute = useUnlinkedApplicationCompleteNextRoute();
    var watchedInputs = formMethods.watch();
    var onSubmit = formMethods.handleSubmit(function (formData) {
        var discountsArray = Object.entries(formData)
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            return (value ? key : null);
        })
            .filter(function (key) { return key !== null; });
        var stringifiedDiscounts = discountsArray.join(", ");
        selectedDiscounts(__assign(__assign({}, commonAnalyticsProperties), { applicableDiscounts: discountsArray, isForSpouse: false }));
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: stringifiedDiscounts, optionSelected: stringifiedDiscounts }));
        dispatch(saveApplicableDiscounts(formData));
        dispatch(updateStatus({ home: UnlinkedApplicationStatus.Complete }));
    });
    var handleClose = React.useCallback(function () {
        dispatch(saveApplicableDiscounts(watchedInputs));
    }, [dispatch, watchedInputs]);
    var handleGoBack = React.useCallback(function () {
        dispatch(saveApplicableDiscounts(watchedInputs));
        goBack();
    }, [dispatch, goBack, watchedInputs]);
    useEffectOnceWhen(function () {
        completedUnlinkedApplication(commonAnalyticsProperties);
        completedHomeUnlinkedApplication(commonAnalyticsProperties);
        postUnlinkedAccount(function () {
            push(nextRoute);
        });
    }, status === UnlinkedApplicationStatus.Complete);
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true, onClose: handleClose, goBackOverride: handleGoBack },
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, null,
                React.createElement(FormProvider, __assign({}, formMethods),
                    React.createElement(ApplicableDiscountsForm, { onSubmit: onSubmit }))))));
}
